import React from "react"
import "../style/skills.css"
import { useInView } from 'react-intersection-observer';




export default function Skills(props)
{
    const { ref, inView, entry } = useInView({
        
        threshold: 0.90,
        triggerOnce: true,
      });

    return(
        <div className="skills_container" id="skills" ref={ref} inView={inView}>
            <div className="skills_box">
            {inView &&  <div className="skill_box_border">
                <div className="skill_box  frontEnd">
                    <div className="img_box">
                    <img className="img img_one" src="images\css_3.png"/>
                    <img className="img img_tree" src="images\logoReact192.png"/>
                    <img className="img img_two" src="images\html5_1.png"/>
                    
                    </div>
                    <div className="skill_header frontEnd_h3">
                    <h3 >Front End</h3>
                    </div>
                    <div className="skill_list">
                    <h3><span>HTML</span></h3>
                    <h3><span>CSS</span>: flex, grid, animation's...</h3>
                    <h3><span>React</span>: redux, hooks, route</h3>
                    <h3><span>JS</span>:  ECMA5 and up</h3>
                    </div>
                </div>
                </div>}

                {inView &&  <div className="skill_box_border">
                <div className="skill_box  frontEnd">
                    <div className="img_box img_box_two ">
                    <img className="img img_backEnd_one" src="images\nod_js_1.png"/>
                    <img className="img img_backEnd_two" src="images\sql.png"/>
                    <img className="img img_backEnd_tree" src="images\mongo.png"/>
                    
                    </div>
                    <div className="skill_header frontEnd_h3">
                    <h3 >Back End</h3>
                    </div>
                    <div className="skill_list">
                    <h3><span>Nod Js</span>: Express, Mongoose, hapi/joi,Bcrypt and json web token</h3>
                    
                    </div>
                </div>
                </div>}
                </div>
                </div>
    )
}